import { CSOcppStatusDto } from '../chargingStationDto';
import { OcppStatus, OcppStatusEnum } from '../ocppStatusModel';

export const chargingStationOperationalStatusNormalizer = (
  operationalStatus: CSOcppStatusDto
): OcppStatusEnum => {
  return operationalStatusMap[operationalStatus];
};

const operationalStatusMap: Record<OcppStatus, OcppStatusEnum> = {
  UNDEFINED: OcppStatusEnum.undefined,
  AVAILABLE: OcppStatusEnum.available,
  PREPARING: OcppStatusEnum.preparing,
  CHARGING: OcppStatusEnum.charging,
  OCCUPIED: OcppStatusEnum.occupied,
  SUSPENDEDEVSE: OcppStatusEnum.suspendedEVSE,
  SUSPENDEDEV: OcppStatusEnum.suspendedEV,
  FINISHING: OcppStatusEnum.finishing,
  RESERVED: OcppStatusEnum.reserved,
  UNAVAILABLE: OcppStatusEnum.unavailable,
  FAULTED: OcppStatusEnum.faulted,
  PROVISIONED: OcppStatusEnum.provisioned,
};

export const operationalStatusToCSOperationStatusDto: Record<
  OcppStatusEnum,
  OcppStatus
> = {
  [OcppStatusEnum.undefined]: 'UNDEFINED',
  [OcppStatusEnum.available]: 'AVAILABLE',
  [OcppStatusEnum.preparing]: 'PREPARING',
  [OcppStatusEnum.charging]: 'CHARGING',
  [OcppStatusEnum.occupied]: 'OCCUPIED',
  [OcppStatusEnum.suspendedEVSE]: 'SUSPENDEDEVSE',
  [OcppStatusEnum.suspendedEV]: 'SUSPENDEDEV',
  [OcppStatusEnum.finishing]: 'FINISHING',
  [OcppStatusEnum.reserved]: 'RESERVED',
  [OcppStatusEnum.unavailable]: 'UNAVAILABLE',
  [OcppStatusEnum.faulted]: 'FAULTED',
  [OcppStatusEnum.provisioned]: 'PROVISIONED',
};
